<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>用户列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 卡片 -->
    <el-card class="box-card" style="margin-top:20px">
      <!-- 搜索  新增-->
      <el-row :gutter="24">
        <el-col :span="19">
          <el-form
            :inline="true"
            :model="searchForm"
            :rules="searchRules"
            ref="searchForRef"
            label-width="80px"
            autocomplete="on"
          >
            <el-form-item required label="门店" size="small" >
              <el-input  @click.native="chooseShop"  v-model="searchForm.shop_name"  clearable placeholder="请选择门店" type="text">
                <span slot="suffix" style="color: #ff0000;">...</span>
              </el-input>
            </el-form-item>
            <el-form-item label="用户名" size="small">
              <el-input v-model="searchForm.name" clearable placeholder="请输入用户名" type="text" name="name_cn"></el-input>
            </el-form-item>
            <el-form-item label="手机号码" size="small">
              <el-input v-model="searchForm.mobile" clearable placeholder="请输入手机号码" type="text" name="mobile"></el-input>
            </el-form-item>
            <el-form-item label="部门名称" size="small">
              <el-cascader
                v-model="searchForm.company_department_id"
                :props="{ value: 'id', label: 'name', checkStrictly: true }"
                :options="departmentData"
                :show-all-levels="false"
                @change="changeDepartmentValue">
              </el-cascader>
            </el-form-item>
            <el-form-item label="角色名称" size="small" prop="role_name">
              <el-select
                v-model="searchForm.role_id"
                placeholder="请选择角色名称"
                @change="changeRoleNameValue($event)"
              >
                <el-option v-for="item in roleNameData"
                           :key="item.role_id"
                           :label="item.name"
                           :value="item.role_id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="状态" size="small">
              <el-select
                v-model="searchForm.status" clearable
                placeholder="请选择状态"
              >
                <el-option label="开启" :value="1"></el-option>
                <el-option label="禁用" :value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="1">
          <el-button type="success" size="small" @click="searchSubmit('searchForm')">搜索</el-button>
        </el-col>
        <el-col :span="1">
          <el-button type="primary" size="small" @click="addData">新增</el-button>
        </el-col>
      </el-row>

      <!-- 表格 -->
      <el-table
        border
        :data="tableLoadData"
        style="width: 100%; margin-top:20px"
        row-key="id"
        stripe
        size="mini"
      >
        <el-table-column :index="indexMethod" type="index" label="序号" width="50"></el-table-column>
        <el-table-column label="登录账号" width="160">
          <template slot-scope="scope">
            <span>
             {{scope.row.user_name}}</span>
          </template>
        </el-table-column>
        <el-table-column label="员工姓名" width="160">
          <template slot-scope="scope">
            <span>
             {{scope.row.employee?scope.row.employee.name_cn:''}}</span>
          </template>
        </el-table-column>
        <el-table-column label="角色" width="140">
          <template slot-scope="scope"  v-if="scope.row.roles!=null" >
            <span v-for="(itm,index) in scope.row.roles" :key="index">
             {{itm.name}}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="100">
          <template slot-scope="scope">

            <el-switch
              :value="scope.row.status===1"
              disabled>
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" width="160">
          <template slot-scope="scope">{{ scope.row.add_time | dateFormat }}</template>
        </el-table-column>
        <el-table-column label="所属校区" width="160">
          <template slot-scope="scope">
            <span>
             {{scope.row.school?scope.row.school.name:''}}</span>
          </template>
        </el-table-column>
        <el-table-column label="绑定老师" width="160">
          <template slot-scope="scope">
            <span>
             {{scope.row.teacher?scope.row.teacher.name:''}}</span>
          </template>
        </el-table-column>
        <el-table-column label="所属门店" width="160">
          <template slot-scope="scope">
            <span>
             {{scope.row.shop?scope.row.shop.name:''}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="300"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button type="warning " icon="el-icon-edit" size='mini' @click="handelEdit(scope.row)">编辑</el-button>
            <el-button icon="el-icon-edit" size='mini' @click="handelSelect(scope.row)">修改密码</el-button>
            <el-dropdown  size="mini"  split-button  trigger="click">
              更多
              <el-dropdown-menu slot="dropdown" trigger="click">
                <el-dropdown-item @click.native="goTeacher(scope.row)">关联老师</el-dropdown-item>
                <el-dropdown-item style="color: #ff0000" @click.native="goDel(scope.row)">删除</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="block" style="margin-top:10px">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>


    </el-card>
    <!-- 新增编辑弹框 -->
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="550px">
      <el-form :model="form" :rules="rules" ref="form" label-width="80px" size="mini">

        <el-form-item label="工号">
          <el-input v-model="form.sn" autocomplete="off" placeholder="请输入工号"></el-input>
        </el-form-item>
        <el-form-item label="用户名" prop="user_name">
          <el-input v-model="form.user_name" autocomplete="off" placeholder="请输入用户名8位数字、字母不分大小写"></el-input>
        </el-form-item>
        <el-form-item label="密码" v-if="id==''">
          <el-input v-model="form.pass" autocomplete="off" placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" v-if="id==''">
          <el-input v-model="form.repass" autocomplete="off" placeholder="请再次输入密码"></el-input>
        </el-form-item>
        <el-form-item label="选择门店">
          <el-select
            v-model="form.shop_id"
            style="width: 180px;"
            placeholder="选择门店">
            <el-option
              v-for="item in shopList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择校区">
          <el-select
            v-model="form.school_id"
            @change="chooseSchool"
            style="width: 180px;"
            placeholder="选择校区">
            <el-option
              v-for="item in schoolList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择老师">
          <el-select
            v-model="form.teacher_id"
            style="width: 180px;"
            placeholder="选择老师">
            <el-option
              v-for="item in teacherList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择员工">
          <el-select
            v-model="form.employee_id"
            filterable
            style="width: 180px;"
            remote
            reserve-keyword
            placeholder="请输入关键词"
           >
            <el-option
              v-for="item in employeeList"
              :key="item.id"
              :label="item.name_cn"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <!--        <el-form-item label="部门名称">-->
        <!--          <el-cascader-->
        <!--            v-model="form.company_department_id"-->
        <!--            :props="{ value: 'id', label: 'name', checkStrictly: true }"-->
        <!--            :options="departmentData"-->
        <!--            :show-all-levels="false"-->
        <!--            @change="changeDepartmentValue">-->
        <!--          </el-cascader>-->
        <!--        </el-form-item>-->
        <el-form-item label="角色名称">
          <el-select
            v-model="form.role_id"
            placeholder="请选择角色名称"
            @change="changeRoleNameValue($event)"
          >
            <el-option v-for="item in roleNameData"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="状态" prop="status">
          <el-select
            v-model="form.status"
            placeholder="请选择状态"
          >
            <el-option label="开启" :value="1"></el-option>
            <el-option label="禁用" :value="0"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="reset_dialogForm('form')">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 新增编辑弹框 -->
    <el-dialog title="修改账号密码" :visible.sync="dialogPassword" width="550px">
      <el-form :model="pwdForm" :rules="pwdRules" ref="pwdForm" label-width="80px">

        <el-form-item label="账号" prop="user_name">
          <el-input v-model="pwdForm.user_name" autocomplete="off" placeholder="请输入账号"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="pwdForm.password" autocomplete="off" placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="repassword">
          <el-input v-model="pwdForm.repassword" autocomplete="off" placeholder="请再次输入密码"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="pwdReset_dialogForm('pwdForm')">取 消</el-button>
        <el-button type="primary" @click="pwdSubmitForm('pwdForm')">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="title" :visible.sync="powerDialogForm" width="550px" size="mini">
      <el-form :model="powerForm" ref="form" label-width="80px">
        <el-form-item label="所属员工" prop="idsArr">
          <el-select v-model="powerForm.employee_id"  collapse-tags placeholder="请选择员工">
            <el-option
              v-for="item in employeeList"
              :key="item.id"
              :label="item.name_cn"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="reset_powerForm('form')">取 消</el-button>
        <el-button type="primary" @click="powerSubmitForm('form')">确 定</el-button>
      </div>
    </el-dialog>

    <eShop  :formData="formData"
            :visible.sync="visible"
            :title="title"
            :closeForm="closeForm"
    />
    <eChooseTeacher  :formData="formData1"
            :visible.sync="visible1"
            :title="title1"
            :closeForm="closeForm1"
    />
    <el-drawer
      title="关联老师"
      size="60%"
      :visible.sync="drawer"
      :with-header="false">
       <div style="margin-top: 30px;">
         <el-container>
           <el-main style="padding:0 20px;">
             <el-form
               size="mini"
               :inline="true"
               :model="addForm"
               ref="addFormRef"
               label-width="120px"
               autocomplete="on"
               :rules="rules"
               class="scrollable"
             >
               <el-form-item required label="关联老师" style="padding-bottom: 12px">
                 <el-input style="width: 300px" @click.native="showTeacher" v-model="addForm.name" placeholder="请选择关联老师"
                           suffix-icon="el-icon-search"
                           clearable type="text">
                 </el-input>
               </el-form-item>
             </el-form>

             <el-table
               ref="multipleTable"
               :data="bindTeacherList"
               stripe
               size="mini"
               border
             >
               <el-table-column :index="indexMethod" type="index" label="序号" width="50"></el-table-column>
               <el-table-column
                 label="校区"
                 width="120"
                 prop="user_id"
               >
               </el-table-column>
               <el-table-column
                 label="姓名"
                 width="120"
                 prop="nickname"
               >
               </el-table-column>
               <el-table-column
                 label="账号"
                 width="120"
                 prop="nickname"
               >
               </el-table-column>
             </el-table>
           </el-main>
         </el-container>
       </div>
    </el-drawer>

  </div>
</template>

<script>
  import eChooseTeacher from "../edu/components/eChooseTeacher";
  import eShop from "../common/eShopList";
  import { hexMD5 } from '../../utils/md5'; //引入
  import moment from 'moment'     //日期时间转换
  export default {
    name: "shopUserList",
    components: {
      eShop,eChooseTeacher
    },
    props: {},
    data() {
      return {
        bindTeacherList:[],
        addForm:{
          name:''
        },
        drawer:false,
        shopList:[],
        formData:{},
        visible:false,


        formData1:{},
        visible1:false,
        title1:'',
        // 搜索
        searchForm: {
          name: "",
          mobile: '',
          status: '',
          company_department_id: '',
          shop_id:sessionStorage.getItem('shop_id'),
          shop_name:null,
          role_id:''
        },
        // 表头

        // 数据
        tableLoadData: [],
        pageNum:1,// 当前页码
        pageSize:10,// 每页大小
        total:0,//总条目数
        id: '',

        searchRules: {
          name: [
            { required: true, message: '请输入工号', trigger: 'blur' },

          ],
          mobile: [
            { required: true, message: "请输入手机号码", trigger: "blur" },
            {
              pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
              message: "只能输入11位手机号码",
            },
          ],
        },
        rules: {
          sn: [
            { required: true, message: '请输入工号', trigger: 'blur' },

          ],
          user_name: [
            { required: true, message: '请输入用户名', trigger: 'blur' },
            {
              min: 3,

              message: "长度至少3字符",
              trigger: "blur",
            }
          ],
          mobile: [
            { required: true, message: "请输入手机号码", trigger: "blur" },
            {
              pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
              message: "只能输入11位手机号码",
            },
          ],
          address: [
            { required: true, message: '请输入地址', trigger: 'blur' },
          ],
          education: [
            { required: true, message: '请输入学历', trigger: 'blur' },
          ],
          // email: [
          //   { required: true, message: "请输入邮箱", trigger: "blur" },
          //   {
          //     pattern: /^\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/,
          //     message: "邮箱格式错误, 请重新输入",
          //   },
          // ],

          role_id: [
            { required: true, message: '请选择角色', trigger: 'change' }
          ],
          department_name: [
            { required: true, message: '请选择部门', trigger: 'change' }
          ],
          status: [
            { required: true, message: '请选择状态', trigger: 'change' }
          ],
          sex: [
            { required: true, message: '请选择性别', trigger: 'change' }
          ],
        },

        dialogFormVisible: false,
        title: '',
        form: {
          id:'',
          sn: "",
          user_name: '',
          mobile: '',
          sex: '',
          company_department_id: '',
          role_id: '',
          address: '',
          education: '',
          status: '',
          role_name:'',
          employee_id:'',
          pass:'',
          repass:'',
          proxy_id:sessionStorage.getItem('proxy_id'),
          school_id:'',
          teacher_id:''
        },
        schoolList:[],
        teacherList:[],
        departmentData: [],
        roleNameData: [],
        // 设置账号密码
        dialogPassword: false,
        pwdRules: {
          user_name: [{ required: true, message: '请输入账号', trigger: 'blur' }],
          password: [
            { required: true, message: '请输入密码', trigger: 'blur' },
            {
              min: 6,
              message: "密码至少6位数字、字符组合",
              trigger: "blur",
            }
          ],
          repassword: [
            { required: true, message: '请输入密码', trigger: 'blur' },
            {
              min: 6,

              message: "密码至少6位数字、字符组合",
              trigger: "blur",
            }
          ]
        },
        pwdForm: {
          user_name: '',
          mobile: '15020145124',
          password: '',
          repassword: '',
          employee_id:'',
        },
        powerDialogForm: false,
        shopDataList: [],
        role_id: '',
        powerForm: {
          idsArr: []
        },
        // powerRules: {
        //   idsArr: [{ required: true, message: '请选择运输公司', trigger: 'change' }]
        // },

        employeeLoading:'',
        employeeList:[],
        employeeStates:[],
      };
    },
    created() {
      this.getShopList();
      this.DataList();
      this.getEmployeeList()
     // this.DepartmentList()
      this.RoleNameList()
      this.getSchoolList()
    },

    mounted() {

    },
    filters: {
      sexFilter(type) {
        if (type == 1) {
          return "男";
        } else if (type == 0) {
          return "女";
        }
      },
      statusFilter(status) {
        if (status == 0) {
          return "启用";
        } else if (status == 1) {
          return "禁用";
        }
      },
      //时间格式化
      dateFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("YYYY-MM-DD HH:mm:ss");
      },

    },
    methods: {
      showTeacher(){
        this.title1="教师选择";
         this.visible1=true;
      },
      closeForm1(){
        this.title1="";
        this.visible1=false;
      },
      goTeacher(){
        this.drawer=true;
      },
      chooseSchool(e){
        const param = {
          school_id:e,
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
        }
        this.$axios.teacherList(param).then(res=>{
          if(res.code == 200){
            this.teacherList =res.data;
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      chooseShop(){
        this.title="选择门店";
        this.visible=true;
      },
      closeForm(){
        this.searchForm.shop_id=this.formData.id;
        this.searchForm.shop_name=this.formData.name;
        this.title="";
        this.visible=false;
      },
      indexMethod(index) {
        return (this.pageNum - 1) * this.pageSize + index + 1
      },
      getEmployeeList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token')
        }
        this.$axios.shopEmployeeList(param).then(res=>{
          if(res.code == 200){
            this.employeeList =res.data;
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      getSchoolList(){
        const param = {
          proxy_id:this.form.proxy_id,
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
        }
        this.$axios.schoolList(param).then(res=>{
          if(res.code == 200){
            this.schoolList =res.data;
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      getShopList(){
        const param = {
          proxy_id:this.form.proxy_id,
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
        }
        this.$axios.shopList(param).then(res=>{
          if(res.code == 200){
            this.shopList =res.data;
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      changeDepartmentValue(e){
        console.log(e);

        let lastElement = e[e.length-1];
        this.form.company_department_id = lastElement
        console.log((lastElement));
        this.searchForm.company_department_id = lastElement
      },
      changeRoleNameValue(e){
        console.log(e);
        this.searchForm.role_id = e
        this.form.role_id = e
      },
       DataList(){

        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          shop_id: this.searchForm.shop_id,
        }
        this.$axios.getShopUserBySchoolListP(param).then(res=>{
          if(res.code == 200){
            this.tableLoadData = res.data.data
            this.total = res.data.total
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      // 设置每页条数
      handleSizeChange(newSize) {
        this.pageSize = newSize
        this.DataList()
      },
      // 分页跳转
      handleCurrentChange(newPage) {
        this.pageNum = newPage
        this.DataList()
      },

      // 新增
      addData() {
        this.title = '新增'
        this.form={};
        this.id='';
        this.dialogFormVisible = true
      },
      handelEdit(row) {
        console.log('000---',row)
        if(row.roles&&row.roles.length>0){
          this.form.role_id=row.roles[0].id;
        }
        this.id = row.id
        this.title = '编辑'
        this.dialogFormVisible = true

        this.form.id =row.id;
        this.form.user_name =row.user_name;
        this.form.school_id =row.school_id;
        this.form.shop_id =row.shop_id;

        this.form.employee_id =row.employee_id;
        this.form.status =row.status;
        const param = {
          school_id:row.school_id,
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
        }
        this.$axios.teacherList(param).then(res=>{
          if(res.code == 200){
            this.teacherList =res.data;
            this.form.teacher_id =row.teacher_id;
          }
        }).catch(error=>{
          console.log(error);
        })
      },

      reset_dialogForm(formName) {
        this.dialogFormVisible = false
        this.$nextTick(() => {
          this.$refs[formName].resetFields()
        })
      },
      submitForm(formName) {
        let _this=this;
        this.$refs[formName].validate((valid) => {
          if (valid) {
              const param = {
                id:this.id,
                sn: this.form.sn,
                user_name: this.form.user_name,
                school_id: this.form.school_id,
                teacher_id: this.form.teacher_id,
                shop_id: this.form.shop_id,
                // mobile: this.form.mobile,
                // sex: this.form.sex,
                company_department_id: this.form.company_department_id,
                role_id: this.form.role_id,
                //address: this.form.address,
                // education: this.form.education,
                status: this.form.status,
                company_id: sessionStorage.getItem('company_id'),
                access_token: sessionStorage.getItem('token'),
                pass:hexMD5(this.form.pass),
                repass:hexMD5(this.form.repass),
                proxy_id: _this.form.proxy_id,
              }
              if(this.form.employee_id){
                param.employee_id=this.form.employee_id;
              }
              this.$axios.shopUserSave(param).then(res =>{
                if(res.code == 200){
                  this.DataList()
                  this.$message.success(res.msg)
                  this.dialogFormVisible = false
                }else{
                  this.$message.error(res.msg);
                }
              })
          }
        })
      },
      searchSubmit() {
        this.tableLoadData=[];
        this.pageNum=1;
        this.DataList();

      },
      handelDel(e) {
        console.log(e);
        this.$confirm('此操作将删除该员工, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const param = {
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token'),
            id: e.data.row.id,
          }
          this.$axios.userDel(param).then(res=>{
            if(res.code == 200){
              this.$message.success(res.msg);
              this.DataList()
            }
          }).catch(error=>{
            console.log(error);
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
          this.DataList()
        });

        this.teamDialog = false
      },
      DepartmentList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
        }
        this.$axios.departmentTree(param).then(res=>{
          if(res.code == 200){
            this.departmentData = res.data
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      RoleNameList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          shop_id:this.searchForm.shop_id
        }
        this.$axios.getShopRoleList(param).then(res=>{
          if(res.code == 200){
            this.roleNameData = res.data
          }
        })
      },
      handelOpen(e) {
        this.$confirm('此操作将修改状态, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const param = {
            id: e.data.row.id,
            status: 1,
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token'),
          }
          this.$axios.cmpUserChangeStatus(param).then(res =>{
            if(res.code == 200){
              this.DataList()
              this.$message.success(res.msg)
              this.statusDialog = false
            }else{
              this.$message.error(res.msg);
            }
          })
        }).catch(() => {
          // 点击取消:不删除了
          this.$message({
            type: 'info',
            message: '已取消修改状态'
          });
          this.DataList()
        });
      },
      handelColse(e) {
        this.$confirm('此操作将修改状态, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const param = {
            id: e.data.row.id,
            status: 0,
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token'),
          }
          this.$axios.cmpUserChangeStatus(param).then(res =>{
            if(res.code == 200){
              this.DataList()
              this.$message.success(res.msg)
              this.statusDialog = false
            }else{
              this.$message.error(res.msg);
            }
          })
        }).catch(() => {
          // 点击取消:不删除了
          this.$message({
            type: 'info',
            message: '已取消修改状态'
          });
          this.DataList()
        });
      },
      handelSelect(row) {
        this.id = row.id;
        this.pwdForm.user_name=row.user_name;
        this.dialogPassword = true
      },
      pwdReset_dialogForm(formName) {
        this.dialogPassword = false
        this.$nextTick(() => {
          this.$refs[formName].resetFields()
        })
      },
      pwdSubmitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            const param = {
              id: this.id,
              password: hexMD5(this.pwdForm.password),
              repassword: hexMD5(this.pwdForm.repassword),
              company_id:sessionStorage.getItem('company_id'),
              access_token:sessionStorage.getItem('token'),
            }
            this.$axios.shopUserChangePsw(param).then(res =>{
              if(res.code == 200){
                this.DataList()
                this.$message.success(res.msg)
                this.dialogPassword = false
              }else{
                this.$message.error(res.msg);
              }
            })
          }
        })
      },
      handelShop(index) {
        console.log(index,333);
        this.shop_id = index.data.row.id
        this.powerForm.idsArr = index.data.row.shop_ids
        console.log('ids',this.powerForm.idsArr)
        // this.powerForm.role_id = index.data.row.role_id
        this.powerDialogForm = true
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
        }
        this.$axios.shipCompanyNoPage(param).then(res=>{
          if(res.code == 200){
            console.log(res,333);
            this.shopDataList = res.data;
          }
        })

      },
      reset_powerForm(formName) {
        this.powerDialogForm = false
        this.$nextTick(() => {
          this.$refs[formName].resetFields()
        })
      },
      powerSubmitForm(formName) {
        console.log(formName,999);
        this.$refs[formName].validate((valid) => {
          if (valid) {
            const param = {
              id: this.shop_id,
              shop_ids: this.powerForm.idsArr,
              company_id: sessionStorage.getItem('company_id'),
              access_token: sessionStorage.getItem('token')
            }
            console.log(param,444);
            this.$axios.cmpUserBindShop(param).then(res =>{
              if(res.code == 200){
                this.DataList()
                this.$message.success(res.msg)
                this.powerDialogForm = false
              }else{
                this.$message.error(res.msg);
              }
            })
          }
        })
      },
      employeeRemoteMethod(query){
        if (query !== '') {
          this.employeeLoading = true;
          let param={
            keywords:query,
            operator_id:sessionStorage.getItem('user_id'),
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token'),
          }
          console.log('param------',param)
          this.$axios.employeeList(param).then(res=>{
            if(res.code == 200){
              this.employeeStates = res.data;
            }
          }).catch(error=>{
            console.log(error);
          })
          setTimeout(() => {
            this.employeeLoading = false;
            this.employeeList = this.employeeSet.filter(item => { // 这里的this.list，换为this.applicantSet
              return item.name;
            });
          }, 1000);
        } else {
          this.employeeList = [];
        }
      },

    },
    computed: {
      employeeSet() {
        return this.employeeStates.map(item => {
          return {id: `${item.id}`, name: `${item.name_cn}`};
        });
      },
    }
  };
</script>
<style>
  .table_name{
    font-weight: bold;
  }
  .table_name:hover{
    color: #409EFF;
    cursor: pointer;
  }
</style>
